var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1269_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 13.6849V12.1824C25.6328 6.00148 20.6211 0.989746 14.4393 0.989746C8.25759 0.989746 3.24585 6.00148 3.24585 12.1824V13.6849",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3812 13.6846H4.87207V21.2986H2.3812C1.48634 21.2986 0.761192 20.5735 0.761192 19.6786V15.3046C0.761192 14.4097 1.48634 13.6846 2.3812 13.6846Z",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4952 13.6846H24.0044V21.2986H26.4952C27.3901 21.2986 28.1152 20.5735 28.1152 19.6786V15.3046C28.1152 14.4097 27.3901 13.6846 26.4952 13.6846Z",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93878 26.7744H12.7939",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24512 23.08V21.2988",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.795 26.7744C12.795 27.6821 13.5313 28.4184 14.439 28.4184C15.3467 28.4184 16.083 27.6821 16.083 26.7744C16.083 25.8667 15.3467 25.1304 14.439 25.1304C13.5313 25.1304 12.795 25.8667 12.795 26.7744Z",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93945 26.7744C4.89859 26.7744 3.24429 25.1201 3.24429 23.0801",
    stroke: "white",
    strokeWidth: 0.857147,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1269_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2121,
    height: 28.2858,
    fill: "white",
    transform: "matrix(-1 0 0 1 28.5449 0.561035)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.97ba8bc4adb1179f51abded227d2ad9b.svg";
export { ForwardRef as ReactComponent };